<template>
    <div>
        <participa-hero></participa-hero>
        <bottom-shape :background="'#3735b3'"></bottom-shape>
        <app-description class="d-none d-sm-block"></app-description>
        <div class="container text-center mb-5">
            <h2 class="mt-5">Desarrolla la app con nosotros</h2>
            <h5 class="font-weight-light d-none d-sm-block">¿Estás listo para participar del proceso de creación de la nueva plataforma Jabrutouch? Descubre las herramientas que estamos desarrollando y dinos al final de la página si te serán útiles para mejorar tu estudio.</h5>
            <p class="font-weight-light d-md-none d-block">¿Estás listo para participar del proceso de creación de la nueva plataforma Jabrutouch? Descubre las herramientas que estamos desarrollando y dinos al final de la página si te serán útiles para mejorar tu estudio.</p>
        </div>
        <vueper-slides fixed-height="355px" class="no-shadow d-block d-sm-none slider" :bullets="false">
            <vueper-slide v-for="(slide, i) in $store.state.tools" :key="i">
                <template v-slot:content>
                    <div class="row no-gutters">
                        <div class="col">
                            <div class="gradient">
                                <img :src="require('../assets/images/tool_back.png')" class="img-fluid phone">
                                <img :src="require('../assets/images/' + slide.icon)" class="img-fluid icon">
                            </div>
                        </div>
                        <div class="col">
                            <div class="gradient">
                                <h5>{{slide.title}}</h5>
                                <span v-html="slide.mobileText"></span>
                            </div>
                        </div>
                    </div>
                </template>
            </vueper-slide>
        </vueper-slides>

        <div class="container">
            <tool class="mt-5" :id="'tools-'+index" v-for="(tool, index) in $store.state.tools" :number="index + 1" :key="index" :tool="tool"/>
            <div class="mt-6 mb-5 text-center">
                <transition name="zoom" mode="out-in">
                    <div id="ti-opinion" v-if="!sent">
                        <h4>
                            Tu opinión nos importa
                        </h4>
                        <p>Escribe tu opinión, comentarios y sugerencias. No olvides ingresar tu email. ¡Gracias!</p>
                        <div class="row">
                            <div class="col-12">
                                <div class="form-group">
                                    <textarea id="text" v-model="form.message" placeholder="Haznos un comentario" class="form-control form-control-lg"/>
                                </div>
                            </div>
                            <div class="col-md-9">
                                <div class="form-group">
                                    <input type="email" id="email" v-model="form.email" placeholder="Ingresa tu email" class="form-control form-control-lg">
                                </div>
                            </div>
                            <div class="col-md-3">
                                <button class="btn btn-secondary btn-block btn-rounded btn-lg" @click="sendForm">Enviar</button>
                            </div>
                        </div>
                    </div>
                </transition>
                <transition name="zoom" mode="out-in">
                    <div class="text-center" v-if="sent">
                        <h4>¡Muchas gracias!</h4>
                        <p>
                            Tus comentarios se han enviado con éxito.
                        <br>
                            Serán muy importantes para el desarrollo de nuestra aplicación.
                        <br>
                            ¡Te mantendremos al tanto de las novedades!
                        </p>
                    </div>
                </transition>
            </div>
        </div>
    </div>
</template>
<script>
import ParticipaHero from './ParticipaHero'
import AppDescription from './AppDescription'
import Tool from './Tool'
import http from '../services/axios'


export default {
    components: {
        ParticipaHero,
        AppDescription,
        Tool,
    },
    data() {
        return {
            form: {
                message: '',
                email: '',
            },
            sent: false,
        }
    },
    methods: {
        sendForm () {
            http.postPayment("send_participa", this.form).then(results => {
                this.message = '¡Muchas gracias!.'
                this.sent = true
            }).catch(err => {
            })
        },
    }
}
</script>
<style lang="scss">
    .slider
    // , .slider *
    {
        height: 310px;
        display: block;
    }
    .vueperslides__arrow {color: #fff}
    .gradient{
        background: linear-gradient(38.4deg, rgba(100, 178, 226, 0.4) 22.37%, rgba(255, 255, 255, 0) 78.57%), #83C9F4;
        height: 200px;
        display: block;
        position: relative;
    }
    .vueperslide {
        display: block;
        margin-top: 70px;
        .phone{
            position: absolute;
            top: -50px;
            width: 80%;
            margin: 0 10px;
        }
        .icon {
            left: 50px;
            position: absolute;
            top: 60px;
        }
    }
</style>